<section class="sorteo-egresados-anahuac">
    <div class="container">
        <div class="row">


            <div class="col-lg-6 my-auto text-center">
                <h1>
                    Consulta la

                    <span class="paragraph d-block">
                        lista de participantes
                    </span>
                    del Sorteo
                    Egresados anáhuac
                </h1>
            </div>

            <div class="col-lg-6 my-auto text-center d-lg-block d-none">
                <img src="/assets/images/soteo-oportuno/participantes-egr.png" class="img-fluid " alt="Participantes Sorteo Egresados Anáhuac" width="320">
            </div>


        </div>
    </div>
</section>


<section class="stc-winners-opt so2">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color:#ff5900 !important;padding: 15px;">
                   LISTA DE PARTICIPANTES del 
                    <span class="d-block">
                       SORTEO egresados anáhuac 2025
                    </span>
                </h2>
            </div>
            <div class="col-md-12">
                <div class="text-center" style="overflow-x: auto;">
                    <label for="search" class="mt-5"
                        style="text-align: left !important; width: 100%; font-weight: 600; font-size: 18px;">Buscar:</label>
                    <input id="search" type="text" class="form-control mb-3" placeholder="Ingresa nombre o folio"
                        [(ngModel)]="searchText" (input)="filterData()" />
                    <table class="table table-striped">
                        <thead class="text-center">
                            <!-- <tr class="text-center">
                        <th class="border-none" colspan="10">Participantes Nuevos</th>
                      </tr> -->
                            <tr class="text-center cols">
                                <th scope="col"><span>FOLIO</span></th>
                                <th scope="col"><span>Nombre</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center"
                                *ngFor="let participante of filteredData | paginate: { itemsPerPage: 21, currentPage: p }">
                                <td>{{ participante.folio }}</td>
                                <td>{{ getFirstName(participante.nombre) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination-controls (pageChange)="p = $event" previousLabel="Anterior" nextLabel="Siguiente">
                    </pagination-controls>
                </div>
            </div>


            <!-- Repite lo mismo para las otras dos tablas -->



            <div class="col-12 mt-5 pt-0 footer-egr">
                <p>
                    <strong>
                        SORTEO DE EGRESADOS ANÁHUAC 2025
                    </strong>
                </p>
                <p>
                    <strong>
                      ENTREGA DE PREMIOS:
                    </strong>
                </p>

                <p>
                  La entrega de los premios menores a 1,500 UMAS $169,710.00 (ciento sesenta y nueve mil setecientos diez pesos 00/100 M.N.) vigente en la República Mexicana para el año 2025 se llevará a cabo dentro de los 20 días hábiles contados a partir de la fecha de realización del sorteo, bajo estricta responsabilidad del permisionario, en las instalaciones de la Universidad Anáhuac México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46, Huixquilucan, Estado de México. C.P. 52786. Piso 7 Edificio de Biblioteca en horario de lunes a jueves de 10:00 a 18:00 horas y los viernes de 10:00 a 14:00 horas.
                </p>


               <p>
                Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses), Constancia de situación fiscal (mes en curso) y CURP.
                En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.
               </p>

               <p>
                Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137.
               </p>



                <p>
                    <strong>
                        PERMISO SEGOB: 20250121PS06
                    </strong>
                </p>
            </div>


        </div>
    </div>
</section>